const { protocol, hostname } = window.location;

export const DEV_MODE: boolean = false;

export const API_BASE_URL = DEV_MODE
    ? `${protocol}//${hostname}:5001/api`
    : `${protocol}//${hostname}/api`;

export const API_TIMEOUT: number = 30000; // in milliseconds
export const MAX_RETRIES: number = 3;
export const AUTH_CHECK_TIME: number = 300000;

export const LIST_CACHE_LIMIT: number = 25;
export const DEPENDENT_CONTENT_CACHE_LIMIT = 10;
export const LOCATION_CACHE_LIMIT = 100;

export const EXTERNAL_ROUTE: string = "/externalservices";
export const AUTH_ROUTE: string = "/auth";
export const LAYOUT_ROUTE: string = "/layout";
export const ASSETS_ROUTE: string = "/assets";
export const LOGS_ROUTE: string = "/logs";

export const LANDING_ROUTES: string[] = [
    "/franquia", 
    "/franquias", 
    "/franquiadiblasi",
    "/diblasifranquia",
    "/franquiasdiblasi",
    "/diblasifranquias",
    "/seja-um-franqueado", 
    "/franquias-agradecimento"
];

export const CLEAN_ROUTES: string[] = [
    "/contato", 
    "/nossas-unidades",
    "/unidades", 
    "/escolha-sua-pizza",
    "/cardapio-sabor",
    "/admin"
];